import { Component, Inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MD_DIALOG_DATA, MdDialogRef, MdSnackBar } from "@angular/material";
import { LicenseService } from "../../../services/LicenseService";
import { AppLoaderService } from "../../../../services/app-loader/app-loader.service";
import { IBillingShippingModel, SCALRenewalType } from "../../../interfaces/LicenseModel";
import Swal from "sweetalert2";
import { Router } from "@angular/router";
import { AdalService } from "../../../shared/adal.service";

@Component({
    selector:'smartlink360-renew-license',
    template:require('./smartlink360-renew-license.component.html'),
    styles:[require('./smartlink360-renew-license.component.css')]
})
export class Smartlink360RenewLicenseComponent{
    renewalType=SCALRenewalType;
        dialogTitle='Renew Smart Link 360 License';
        errorMessage='';
        renewSmartlink360LicenseForm:FormGroup;
        isRadioButtonDisabled=false;
        selectedRow;
        billingShippingDetail:IBillingShippingModel={
            ODataEtag:'',
            Number:'',
            publicId:'',
            CustomerNo:'',
            publicSalesPersoncode:'',
            BillToName:'',
            BillToAddress1:'',
            BillToAddress2:'',
            BillToCity:'',
            BillToState:'',
            BillToZipcode:'',
            BillToCountryCode:'',
            ShipToCode:'',
            ShipToName:'',
            ShipToAddress1:'',
            ShipToAddress2:'',
            ShipToCity:'',
            ShipToState:'',
            ShipToZipcode:'',
            ShipToCountryCode:'',
            CustomerTelephone:'',
            CustomerEmailAddress:'',
            CustomerFaxno:'',
            ShippingTelephoneno:'',
            ShippingFaxno:'',
            ShippingEmailAddress:'',
            Rep1:'',
            Rep2:'',
            Sales1:'',
            Sales2:''
        };
        customerId=0;
        shippingAddressId=0;
        shouldFetchSalesOrderNo=false;
        Smartlink360PurchaseLicenseData;
        SelectedCustomerLicenseDetail;
        LicenseRenwalDetails;
        error="";
        SCALRenewalTypeList=[];
        SelectedLicenseKey='';
        isBillingShippingDetailFetched=false;
        selectedLicenseDetailIdList=[];
        selectedNoOfUserRenewalList=[];
        isLoading=false;
        currentTime=Date.now();
        prevSalesOrderNo='';
        constructor(
            private dialogRef:MdDialogRef<Smartlink360RenewLicenseComponent>,
            private formBuilder:FormBuilder,
            private licenseService:LicenseService,
            private appLoader:AppLoaderService,
            private snackBar:MdSnackBar,
            private adalService:AdalService,
            private router:Router,
            @Inject(MD_DIALOG_DATA) public dialogData: any
        ){
            if (!this.adalService.getCachedToken()) {
                this.dialogRef.close(null);
                this.router.navigate(["login"]);
            }
            this.Smartlink360PurchaseLicenseData=this.dialogData.Smartlink360PurchaseLicenseData;
            this.SelectedCustomerLicenseDetail=this.dialogData.SelectedLicenseDetail;
            this.buildForm();
            Object.keys(SCALRenewalType).filter((type) => isNaN(Number(type))).forEach((key,index)=>{
                this.SCALRenewalTypeList.push({
                    name:key,
                    value:SCALRenewalType[key]
                })
            })
            this.billingShippingDetail.BillToName=this.SelectedCustomerLicenseDetail.BillToName;
            this.billingShippingDetail.BillToAddress1=this.SelectedCustomerLicenseDetail.BillToAddress1;
            this.billingShippingDetail.BillToAddress2=this.SelectedCustomerLicenseDetail.BillToAddress2;
            this.billingShippingDetail.BillToCity=this.SelectedCustomerLicenseDetail.BillToCity;
            this.billingShippingDetail.ShipToName=this.SelectedCustomerLicenseDetail.ShipToName;
            this.billingShippingDetail.ShipToAddress1=this.SelectedCustomerLicenseDetail.ShipToAddress1;
            this.billingShippingDetail.ShipToAddress2=this.SelectedCustomerLicenseDetail.ShipToAddress2;
            this.billingShippingDetail.ShipToCity=this.SelectedCustomerLicenseDetail.ShipToCity;
            this.billingShippingDetail.ShipToState=this.SelectedCustomerLicenseDetail.ShipToState;
        }
        buildForm(){
            this.renewSmartlink360LicenseForm=this.formBuilder.group({
                RenewalType:['',[Validators.required]],
                PurchaseDate:['',Validators.required],
                SupportValidityYear:[24,Validators.required],
                SalesOrderNo:['',[Validators.required]],
            })
        }
        blurSalesOrderEvent(){
            if(this.prevSalesOrderNo.trim().toUpperCase()==this.renewSmartlink360LicenseForm.value.SalesOrderNo.trim().toUpperCase()){
                return;
            }
            this.prevSalesOrderNo=this.renewSmartlink360LicenseForm.value.SalesOrderNo
            setTimeout(() => {
                this.shouldFetchSalesOrderNo=true;
                this.isBillingShippingDetailFetched=false;
            }, 150);
        }
        checkSalesOrderNo(){
            if(this.dialogData.Smartlink360PurchaseLicenseData){
                let exists=this.dialogData.Smartlink360PurchaseLicenseData.some((element)=>{
                    if(element != null){
                        return this.renewSmartlink360LicenseForm.value.SalesOrderNo.toUpperCase().trim()==element.SalesOrderNo.toUpperCase().trim()
                    }
                    else{
                        return false;
                    }
                });
                if(exists){
                    Swal.fire({
                        title:"This sales order no already exists",
                        text:"Are you sure you want to use this Sales Order No?",
                        showCancelButton:true,
                        showCloseButton:true,
                        showConfirmButton:true,
                        confirmButtonText:"Yes",
                        confirmButtonColor:"#FFCA28",
                        cancelButtonText:"No",
                    }).then((result)=>{
                        if(result.isConfirmed){
                           this.shouldFetchSalesOrderNo=true;
                           this.isBillingShippingDetailFetched=false;
                           this.getBillingShippingDetail();
                        }
                        else{
                            this.shouldFetchSalesOrderNo=false;
                            this.isBillingShippingDetailFetched=false;
                            this.renewSmartlink360LicenseForm.patchValue({
                                SalesOrderNo:""
                            });
                        }
                    })
                }
                else{
                    this.shouldFetchSalesOrderNo=true;
                    this.isBillingShippingDetailFetched=false;
                    this.getBillingShippingDetail();
                }
            }
            else{
                this.shouldFetchSalesOrderNo=true;
                this.isBillingShippingDetailFetched=false;
                this.getBillingShippingDetail();
            }
        }
        getBillingShippingDetail(){
            let salesOrderNo=this.renewSmartlink360LicenseForm.value.SalesOrderNo;
            if(salesOrderNo!=''){
                if(this.shouldFetchSalesOrderNo){
                    this.appLoader.open()
                    this.licenseService.getBillingShippingDetail(salesOrderNo).subscribe((data)=>{
                        if(!data.IsError && data.DataObject!=null){
                            this.billingShippingDetail=data.DataObject;
                            this.isBillingShippingDetailFetched=true;
                            this.error='';
                        }
                        else{
                            this.isBillingShippingDetailFetched=false;
                            this.error=data.Error;
                        }
                        this.appLoader.close()
                    })
                }
                else{
                    this.error="Please select other sales order number."
                }
            }
            else{
                this.error="Sales Order No is required";
                this.isBillingShippingDetailFetched=false;
            }
        }
        onSave(){
            setTimeout(() => {
                if(!this.isBillingShippingDetailFetched){
                    this.error="Please fetch the customer billing and shipping details!";
                    return;
                }
                this.appLoader.open()
                this.licenseService.addBillingShippingDetail(this.billingShippingDetail).subscribe((data)=>{
                    if(!data.IsError && data.DataObject!=null){
                        let model={   
                            LicenseId:this.SelectedCustomerLicenseDetail.LicenseId,
                            CustomerId:data.DataObject.CustomerId,
                            ShippingAddressId:data.DataObject.ShippingAddressId,
                            RenewType:this.renewSmartlink360LicenseForm.value.RenewalType,
                            PurchaseInvoiceDate:this.renewSmartlink360LicenseForm.value.PurchaseDate,
                            SalesOrderNo:this.renewSmartlink360LicenseForm.value.SalesOrderNo,
                            SupportValidityMonths:this.renewSmartlink360LicenseForm.value.SupportValidityYear,
                            CreatedBy:Number(localStorage.getItem('userid')),
                            UpdatedBy:Number(localStorage.getItem('userid'))
                        }
                        this.licenseService.renewSmartLink360License(model).subscribe((data)=>{
                            if(!data.IsError && data.DataObject!=null){
                                this.Smartlink360PurchaseLicenseData=data.DataObject;
                                this.dialogRef.close(this.Smartlink360PurchaseLicenseData)
                                this.appLoader.close();
                                this.snackBar.open("License renewed successfully!","",{
                                    duration:2000
                                })
                            }
                        })
                    }
                })
            }, 300);
        }
        onCancel(){
            this.dialogRef.close(this.Smartlink360PurchaseLicenseData);
        }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/smartlink360/smartlink360-renew-license/smartlink360-renew-license.component.ts